<template>
  <modal
    width="438px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    class="score-modal"
    :class="{ 'loading-mask': showSaveLoading }"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close">
    <div class="wrap" slot="content">
      <div v-if="!showSaveLoading" class="bg">
        <h3 :class="{ 'weisheng-h3': $route.path.split('/')[1].indexOf(weishengRoute) >= 0 }">恭喜你完成了考试</h3>
        <p v-if="showScoreNotComplete" class="objective">成绩暂时未公布</p>
        <!-- 只有主观题分数时只展示总分 -->
        <p v-else-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0 && info.has_subjective && !info.has_objective" class="bg-score">{{info.score_subject}}<span>分</span></p>
        <!-- 只有客观题分数时只展示总分 -->
        <p v-else-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0 && !info.has_subjective && info.has_objective" class="bg-score">{{info.score_object}}<span>分</span></p>
        <!-- 主观题和客观题都有时分开展示 -->
        <div v-else-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0 && info.has_subjective && info.has_objective" class="score-split">
          <div class="score-item">
            <div class="score-label">客观题</div>
            <div class="score-value">{{info.score_object}}分</div>
          </div>
          <div class="score-item">
            <div class="score-label">主观题</div>
            <div class="score-value" v-if="info.score_subject !== -1">{{info.score_subject}}分</div>
            <div class="score-value pending" v-else>待批改</div>
          </div>
        </div>
        <p v-else class="bg-score"></p>
        <div class="time-cost" v-if="!showIsPass">
          <span class="time-title">答题用时:</span><span class="time">{{info.time_cost | timeFactory}}</span>
        </div>
        <div v-else class="info">
          <div class="info-item">
            <p class="info-value">{{info.time_cost | timeFactory}}</p>
            <p class="info-title">答题用时</p>
          </div>
          <div v-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0" class="info-item">
            <p class="info-value">{{ pass ? '通过' : '未通过' }}</p>
            <p class="info-title">通过状态</p>
          </div>
        </div>
        <div class="btn-wrap">
          <a class="btn" @click="showPaper" v-if="canViewPaper" :style="`color: #fff;background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`">
            {{$route.path.split('/')[1].indexOf(weishengRoute) >= 0 ? '确定' : '查看答卷'}}</a>
          <a class="btn"
             v-if="$route.path.split('/')[1].indexOf('nctsimutest') >= 0
             || repeat_test === 1
             || $route.path.split('/')[1].indexOf(eduteacherRoute) >= 0
             || $route.path.split('/')[1].indexOf(nocbcmRoute) >= 0"
             @click="reset"
             :style="'border: 1px solid'+$store.state.theme.themeColor+ 'color: '+$store.state.theme.themeColor">
            重新考试</a>
        </div>
      </div>
      <div class="loading-mask" v-show="showSaveLoading">
        <div class="loading-wrap">
          <looping-rhombuses-spinner
            :animation-duration="2500"
            :rhombus-size="30"
            :color="$store.state.theme.themeColor.split(';')[0]"
            class="loading-icon"
          />
          <p>数据加载中...</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import { get, post } from '@/utils/ajax'
import { getExamId, isCppTest } from '@/utils'
import { mapState } from 'vuex'
export default {
  components: {
    Modal,
    LoopingRhombusesSpinner
  },
  props: {
    show: Boolean
  },
  data () {
    return {
      pass: '',
      timer: null,
      showSaveLoading: true,
      info: {
        time_cost: 0
      },
      repeat_test: 0,
      weishengInfo: {}
    }
  },
  filters: {
    timeFactory (timestamp) {
      timestamp = timestamp / 1000
      // let d = parseInt(timestamp / (24 * 60 * 60))
      // let h = parseInt((timestamp / (60 * 60)) % 24)
      let m = parseInt((timestamp / 60) % 60)
      let s = parseInt((timestamp) % 60)
      // d = d < 10 ? 0 + '' + d : d
      // h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return `${m}分${s}秒`
    }
  },
  computed: {
    ...mapState(['weishengRoute', 'eduteacherRoute', 'nocbcmRoute']),
    examineeInfo () {
      return this.$store.state.examineeInfo
    },
    canViewPaper () {
      return this.info.view_answer_sheet === 1
    },
    showIsPass() {
      return this.info.assessment_standard_config === 1
    },
    // 是否展示成绩还未公布
    showScoreNotComplete() {
      // 只有主观题，没有客观题，且主观题分数为-1，则展示成绩还未公布
      return this.info.has_subjective && !this.info.has_objective && this.info.score_subject === -1
    }
  },
  mounted () {
    // this.showSaveLoading = true
    setTimeout(async () => {
      await this.check()
      await this.getResult()
      this.showSaveLoading = false
    }, 500)
  },
  methods: {
    async getResult () {
      const res = await get(`/home/exams/${localStorage.examId}/examinees/${localStorage.user_id}/score_result`)
      this.info = res
      this.pass = res.score >= res.pass_score
      if (!res.score_complete) {
        this.timer = setTimeout(() => {
          this.getResult()
        }, 1000)
      } else {
        // 由于前端的不稳定性，如关掉页面不可调用这个接口，所以功能还需后端做
        await this.funcAPI()
      }
    },
    async check () {
      const { repeat_test } = await get(`/home/exams/check/${localStorage.examId}`)
      this.repeat_test = repeat_test
    },
    async funcAPI () {
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        await this.weishengToken()
      } else if (this.$route.path.split('/')[1].indexOf(this.eduteacherRoute) >= 0) {
        await this.eduteacherAPI()
      }
    },
    async weishengToken () {
      // 传入API名以及请求参数对象
      const res = await post('/home/outsize/weisheng/users', { uniqId: localStorage.UniqId })
      // this.jsp('getUser.php', { UniqId: localStorage.UniqId || this.$route.query.uniq_id }).then(async (res) => {
      this.weishengInfo = res.data.user
      await post(`/home/outsize/weisheng/score`, {
        exam_id: localStorage.examId,
        score: this.info.score,
        token: this.weishengInfo.Token || '',
        uniqId: localStorage.UniqId || this.$route.query.uniq_id,
        user_id: localStorage.user_id
      })
      // }).catch((err) => {
      //   console.log(err)
      // })
    },
    async eduteacherAPI () {
      const info = JSON.parse(localStorage.eduTeacher)
      const infoItem = info['exam' + localStorage.examId]
      const body = {
        studentLearnRecordAddDTO: {
          unitId: infoItem.unitId,
          lessonId: infoItem.lessonId,
          resourceId: infoItem.resourceId,
          userId: localStorage.user_id,
          type: infoItem.type
        },
        studentTestRecordAddDTO: {
          examId: localStorage.examId,
          score: this.info.score,
          userId: localStorage.user_id
        }
      }
      await post('/home/outsize/eduzone/score', body)
    },
    async reset () {
      await post(`/home/edu/examinees/exams/reset`, { exam_id: localStorage.examId, examinee_id: this.examineeInfo.examinee_id })
      localStorage.removeItem('currentQuestionId') // 去掉上一次答题进度的缓存
      await this.startTest()
      location.reload()
    },
    async startTest() { // 重置开始考试的状态
      await post(`/home/edu/examinees/start/${localStorage.examId}/${this.examineeInfo.examinee_id}`)
    },
    // 查看试卷
    async showPaper () {
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        const redirection = await get(`/home/exams/${localStorage.examId}/regions`)
        if (redirection.over_link === 1) {
          await this.$store.dispatch('logout')
          localStorage.clear()
          if (window.location.href.indexOf(CONFIG.noc2025) === -1) {
            this.$router.replace({ name: 'login' })
          }
        } else {
          this.$router.replace({ name: 'list' })
        }
      } else {
        if (isCppTest()) {
          this.$router.push({ name: 'showPaper', query: { examId: getExamId() }, params: { noBackTip: true } })
        } else {
          window.open(`${location.origin}/${location.href.split('/')[3]}/showPaper?examId=${getExamId()}`, '_blank')
        }
      }
    },
    async close () {
      this.$emit('update:show', false)
      const redirection = await get(`/home/exams/${localStorage.examId}/regions`)
      if (redirection.over_link === 1) {
        await this.$store.dispatch('logout')
        localStorage.clear()
        if (window.location.href.indexOf(CONFIG.noc2025) === -1) {
          this.$router.replace({ name: 'login' })
        }
      } else {
        this.$router.replace({ name: 'list' })
      }
    }
  }
  // destroyed () {
  //   clearTimeout(this.timer)
  //   this.timer = null
  // }
}
</script>

<style lang="scss" scoped>
.wrap {
  // padding-bottom: 31px;
  border-radius: 4px;
  overflow: hidden;
}
.bg {
  background: url('~@/assets/images/score-bg3.png') no-repeat top / 439px 370px;
  overflow: hidden;
  h3 {
    color: #fff;
    font-size: 24px;
    text-align: center;
    margin: 87px 0 15px;
    text-shadow:0px 2px 4px rgba(57,126,253,1);
  }
  .weisheng-h3 {
    margin: 117px 0 0px;
  }
  .bg-score {
    color: #fff;
    font-weight: 600;
    line-height:84px;
    height: 84px;
    font-size: 60px;
    margin-left: 12px;
    text-align: center;
    text-shadow: 0px 2px 4px rgba(57,126,253,1);
  }
  .score-split {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin: 15px 0 30px 0;
    .score-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 100px;
      .score-label {
        color: #fff;
        font-size: 16px;
        margin-bottom: 12px;
        text-shadow: 0px 2px 4px rgba(57,126,253,1);
        font-weight: 400;
      }
      .score-value {
        color: #fff;
        font-size: 24px;
        text-shadow: 0px 2px 4px rgba(57,126,253,1);
        line-height: 1;

        &.pending {
          font-size: 24px;
          font-weight: 500;
          line-height: 1.2;
        }
      }
    }
  }
  .time-cost {
    font-size: 16px;
    text-align: center;
    margin-top: 148px;
    background-color: #ffffff;
  }
  .time-title {
    color: #666;
  }
  .time {
    font-size: 20px;
    font-weight: 400;
    color: #333;
    vertical-align: -1px;
  }
  span {
    font-size: 18px;
    margin-left: 8px;
    font-weight: 300;
  }
  .objective {
    font-size: 16px;
    margin: 15px 0 0 0;
    font-weight: 300;
    text-align: center;
    color: #fff;
  }
}
.info {
  background: #fff;
  display: flex;
  margin: 80px 0 0 0;
  position: relative;
  .info-item {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .info-value {
      text-align: center;
      color: #333;
      font-size: 18px;
      font-weight: 500;
      margin: 10px 0 0 0;
      padding-bottom: 6px;
    }
  }
  p {
    flex: 1;
    color: #666;
    font-size: 16px;
    font-weight: 300;
    text-align: center;

  }
}
.btn-wrap {
  display: flex;
  background: #fff;
  overflow: hidden;
  min-height: 60px;
}
.btn {
  display: block;
  width: 160px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  border-radius: 4px;
  margin: 20px auto 50px;
  // padding-bottom: 31px;
  text-align: center;
}
.loading-mask {
  position: absolute;
  top: 20px;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-wrap {
    display: flex;
    flex-direction: column;
    width: 100px;
    height: 100px;
    align-items: center;
    justify-content: center;
    p {
      font-size: 14px;
      margin-top: 20px;
      color: #fff;
    }
  }
}
  /deep/ .dialog {
    .modal-head {
      border-bottom: none;
    }
    .close-icon {
      top: 80px !important;
    }
  }
  .loading-mask {
    /deep/ .close-icon {
      display: none;
    }
  }
</style>

<style lang="scss">
.score-modal .content {
  padding: 0px;
}
.score-modal .dialog {
  background-color: transparent;
  border: none;
  box-shadow: none;
  .modal-head .close-icon {
    top: 40px;
    svg {
      fill: #fff;
      width: 17px;
      height: 17px;
    }
  }
}
</style>
